import React from "react";
import "./Footer.scss";
import logoDreams from "../../images/logo.png";

const Footer = () => {
  return (
    <footer className="footerDreams">
      <div className="container">
        <div className="footerDreams__top">
          <div className="footerDreams__brand">
            <img src={logoDreams} alt="Dreams XV" />

            <p>
              Donde los sueños de XV años comienzan a hacerse realidad.
            </p>
          </div>

          <div className="footerDreams__links">
            <h3>Explora</h3>
            <a href="#inicio">Inicio</a>
            <a href="#categorias">Categorías</a>
            <a href="#inspiracion">Inspiración</a>
            <a href="#como-funciona">Cómo funciona</a>
          </div>

          <div className="footerDreams__links">
            <h3>Enlaces</h3>
            <a
              href="https://dreamsxv.com/catalogo.php"
              target="_blank"
              rel="noreferrer"
            >
              Ver catálogo
            </a>
            <a href="#proveedores">Únete como proveedor</a>
            <a href="#porque-dreams">¿Por qué Dreams XV?</a>
          </div>

          <div className="footerDreams__links">
            <h3>Redes sociales</h3>
            <a href="https://www.facebook.com/share/1AwNANLavu/?mibextid=wwXIfr" target="_blank" rel="noreferrer">
              Facebook
            </a>
            <a href="https://www.instagram.com/dreams_xv_?igsh=Zno1YzAxMG4yY2Fi" target="_blank" rel="noreferrer">
              Instagram
            </a>
          </div>
        </div>

        <div className="footerDreams__bottom">
          <p>© 2026 Dreams XV. Todos los derechos reservados.</p>

          <a
            href="#"
            className="footerDreams__signature"
          >
            Dreams XV by Real Results
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;